"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const axios_1 = __importDefault(require("axios"));
// @ts-ignore
const querystring_1 = __importDefault(require("querystring"));
function translate(parameters) {
    return __awaiter(this, void 0, void 0, function* () {
        const sub_domain = parameters.free_api ? 'api-free' : 'api';
        return axios_1.default.post(`https://${sub_domain}.deepl.com/v2/translate`, querystring_1.default.stringify(parameters));
    });
}
module.exports = translate;
